import React from "react";
import { Container } from "@mui/material";

const StyleItem = ({ data }) => {
  return (
    <Container>
      <div className="styleItem-section">
        <h3 style={{ margin: 0 }}>{data.heading}</h3>
        <p className="styleitemtext">{data.text}</p>
      </div>
    </Container>
  );
};

export default StyleItem;
